import { TranslateOptions } from "./types/TranslateOptions";

export const defaultTranslateOptions: TranslateOptions = {
  from: "auto",
  to: "en",
  hl: "en", // Host language
  tld: "com",
  rpcids: "MkEWBc",
};
